export const LOCAL = 'L';
export const VISITANTE = 'V';
export const NEUTRAL = 'N';
